(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.controller.debt-financing
  (:require
   [frontend.ui.page.lp-portal.report.util :as util]
   [frontend.ui.component.lp-portal.report.controller :as report-ctl]
   [frontend.ui.component.lp-portal.donut-chart.view :as donut-chart]
   [frontend.ui.component.chart.utils :as chart-utils]))

(defn- lender-by-loan-commitment
  [{:keys [labels commitment]}]
  (map vector labels commitment))

(defn- lender-by-loans-outstanding
  [{:keys [labels loans-outstanding]}]
  (map vector labels loans-outstanding))

(defn debt-financing
  [{:keys [report-data] :as props}]
  {:debt-financing-text         (report-ctl/rich-content props :debt-financing-text)
   :debt-key-figures            (report-ctl/with-footnote
                                 props
                                 :debt-key-figures-footnotes
                                 (:portfolio-debt-key-figures report-data))
   :portfolio-debt-financing    (report-ctl/with-footnote
                                 props
                                 :debt-financing-table-footnotes
                                 (:portfolio-debt-financing report-data))
   :lender-by-loan-commitment   (report-ctl/with-footnote
                                 props
                                 :lender-by-loan-commitment-footnotes
                                 (donut-chart/donut-chart-config
                                  (lender-by-loan-commitment
                                   (:chart-data-debt-financing
                                    report-data))
                                  {:data-label-formatter
                                   chart-utils/pie-float-label-formatter-divide-m}))
   :lender-by-loans-outstanding (report-ctl/with-footnote
                                 props
                                 :lender-by-loans-outstanding-footnotes
                                 (donut-chart/donut-chart-config
                                  (lender-by-loans-outstanding
                                   (:chart-data-debt-financing
                                    report-data))
                                  {:data-label-formatter
                                   chart-utils/pie-float-label-formatter-divide-m}))})
